// The inline Google tag queues events while the Analytics script loads.
export function trackEvent(eventName) {
  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, { send_to: "G-2RXVNBW28L" });
  }
}
